module.exports = __webpack_public_path__ + "media/images/amanata-grey-bc81f1034845ab5033d0afdf05567580.jpeg";